import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as bootstrap from "bootstrap";
import * as $AB from 'jquery';

@Component({
  selector: 'app-uploadmodal',
  templateUrl: './uploadmodal.component.html',
  styleUrls: ['./uploadmodal.component.css']
})
export class UploadmodalComponent implements OnInit {
modal:any;
type_s3path:any;

  constructor() { }

  ngOnInit(): void {
   
    $("#localpath").click(function(){
  $(".inputlocalpath").trigger('click');
  });

  }

               onSubmit_dts3path(form:NgForm){
                    this.type_s3path=form.value.s3_path;
                      }

  path(event)
  {
    $(".uploadmodal").modal("hide");
    setTimeout(function() {
         $(".uploadpath").modal("show");
     }, 300);
  }

}
